/* eslint-disable no-unused-expressions */
import * as React from "react";
import { useCookies } from "react-cookie";
import jMoment from "moment-jalaali";
// Local and shared component
import Main from "screens/Auth/components/Main";
import Maybe from "components/Maybe";
import Enamad from "components/Enamad";
import GetCode from "./components/GetCode";
import GetMobile from "./components/GetMobile";
import GetPassword from "./components/GetPassword";
import AnswerQuestion from "./components/AnswerQuestion";
import ExternalLinks from "screens/Auth/components/ExternalLinks";
// Services
import AuthService from "services/http/endpoints/auth";
// Hooks and utilities
import useUser from "hooks/useUser";
import showNotify from "helpers/notify";

interface IState {
	mobile: string;
	newPassword: string;
	key: string;
	question: string;
	state: "need_mobile" | "need_code" | "need_answer" | "need_password" | string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAction extends Partial<IState> {}

function reducer(state: IState, action: IAction): IState {
	return { ...state, ...action };
}

const Forget: React.FC = () => {
	const { forgetPassword } = useUser();
	const [loading, setLoading] = React.useState(false);
	const [cookies, setCookie, removeCookie] = useCookies(["forgetPassMobile"]);
	const initialState = () => ({ mobile: "", state: "need_mobile" } as IState);

	const [store, dispatch] = React.useReducer(reducer, initialState());

	React.useEffect(() => {
		if (cookies.forgetPassMobile) {
			dispatch({ mobile: cookies.forgetPassMobile, state: "need_code" });
		}
	}, [cookies.forgetPassMobile]);

	async function handleSubmitNeedMobile(values: any): Promise<void> {
		setLoading(true);
		try {
			await AuthService.initResetPassword(values.mobile);
			// @ts-ignore
			dispatch({ mobile: values.mobile, state: "need_code" });
			setCookie("forgetPassMobile", values.mobile, {
				expires: jMoment()
					.add(2, "m")
					.toDate(),
				path: "/",
			});
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}

	async function handleSubmitGetStrategy(values: any): Promise<void> {
		setLoading(true);
		try {
			const res = await AuthService.getStrategy(store.mobile, values.code);
			if (res === "WRONG_CODE") {
				showNotify({ text: "کد نامعتبر است." });
			} else if (res === "RESET_PASS_PHASE") {
				dispatch({ state: "need_password", key: values.code });
			} else if (res === "ANSWER_QUESTION_PHASE") {
				const res = await AuthService.getQuestion(store.mobile, values.code);
				dispatch({ state: "need_answer", question: res, key: values.code });
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}

	async function handleSubmitAnswerQuestion(values: any): Promise<void> {
		setLoading(true);
		try {
			const answerIsCorrect = await AuthService.answerQuestion(store.mobile, store.key, values.answer);
			if (answerIsCorrect) {
				const res = await AuthService.getStrategy(store.mobile, store.key);
				if (res === "WRONG_CODE") {
					showNotify({ text: "کد نامعتبر است." });
				} else if (res === "RESET_PASS_PHASE") {
					dispatch({ state: "need_password" });
				} else if (res === "ANSWER_QUESTION_PHASE") {
					const question = await AuthService.getQuestion(store.mobile, store.key);
					dispatch({ state: "need_answer", question });
				}
			} else {
				showNotify({ text: "پاسخ سوال صحیح نیست." });
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}

	async function handleSubmitNeedPassword(values: any): Promise<void> {
		try {
			setLoading(true);
			await forgetPassword({
				key: store.key,
				newPassword: values.newPassword,
				mobile: store.mobile,
			});
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	}

	function handleChangeUsername(): void {
		removeCookie("forgetPassMobile");
		dispatch({ state: "need_mobile" });
	}

	return (
		<Main title="بازنشانی رمز عبور" subTitle="بازنشانی رمز عبور">
			<Maybe condition={store.state === "need_mobile"}>
				<GetMobile onSubmit={handleSubmitNeedMobile} loading={loading} />
			</Maybe>

			<Maybe condition={store.state === "need_code"}>
				<GetCode inputValue={store.mobile} onSubmit={handleSubmitGetStrategy} onChangeUsername={handleChangeUsername} loading={loading} />
			</Maybe>

			<Maybe condition={store.state === "need_answer"}>
				<AnswerQuestion onSubmit={handleSubmitAnswerQuestion} question={store.question} loading={loading} />
			</Maybe>

			<Maybe condition={store.state === "need_password"}>
				<GetPassword onSubmit={handleSubmitNeedPassword} loading={loading} />
			</Maybe>
			<ExternalLinks login />
			<Enamad />
		</Main>
	);
};

export default Forget;
